import React, { useEffect } from 'react';

import Button from '@/components/Button';
import signInStyles from '@/components/SignIn/SignIn.module.scss';
import Svg from '@/components/Svg';
import parseJwt from '@/helpers/common';
import { logError } from '@/helpers/logger/logUtils';

type AppleLoginButtonProps = {
  clientId: string;
  handleAppleLogin: Function;
  redirectURI: string;
  variant: 'SIGN_UP' | 'SIGN_IN' | '';
};

const AppleLoginButton = ({ clientId, handleAppleLogin, redirectURI, variant }: AppleLoginButtonProps) => {
  useEffect(() => {
    const windowObj = window;
    const initAppleAuth = () => {
      windowObj?.AppleID.auth.init({
        clientId,
        scope: 'name email',
        redirectURI,
        state: 'login',
        usePopup: true,
        responseType: 'code',
        responseMode: 'query',
      });
    };

    if (!windowObj?.AppleID && redirectURI) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
      script.onload = initAppleAuth;
      document.body.appendChild(script);
    }
  }, [clientId, redirectURI]);

  const handleSignIn = () => {
    const windowObj = window;
    windowObj?.AppleID.auth
      .signIn()
      .then((data: any) => {
        if (data) {
          const { authorization, user } = data;
          const idToken = parseJwt(authorization.id_token) || {};
          const { sub } = idToken;
          handleAppleLogin(sub, user);
        }
      })
      .catch((error: Error) => {
        logError(`Apple login failure: ${error.message}`);
      });
  };

  return (
    <Button className={`${signInStyles.socialButton} ${signInStyles.appleButton}`} onClick={handleSignIn}>
      <Svg glyph="apple" iconId="apple-logo" width={30} height={30} className={signInStyles.apple} />
      <span>{`Sign ${variant === 'SIGN_UP' ? 'up' : 'in'} with Apple`}</span>
    </Button>
  );
};

export default AppleLoginButton;
